export default {"src":"/_next/static/media/arrow-mobile.f35fb58a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};